import { generatePath, useHistory, useParams } from "react-router-dom";
import routing from "routing";
import CourseInfo, {
	type CourseDetails,
} from "src/components/Course/CourseInfo";
import { LessonsList } from "src/components/Course/lessons/Lessons";
import CoursesSkeleton from "src/components/NewComponents/Skeletons/CoursesContent";

import { useGetCourse } from "../../hooks/useCourses";

function Course() {
	const history = useHistory();
	const { id, sectionId } = useParams<{ id: string; sectionId: string }>();
	const { data, isLoading } = useGetCourse(id);
	const course: CourseDetails = data;
	if (isLoading) {
		return <CoursesSkeleton className="" />;
	}

	if (!sectionId) {
		const firstSectionId =
			course.lastResolvedLesson?.sectionId ?? course.sections[0].id;
		history.replace(
			generatePath(routing.paths.course, { id, sectionId: firstSectionId }),
		);
	}

	const section = course.sections.find((s) => s.id === +sectionId);

	return (
		<div className="course-lessons-box">
			<div className="flex-1 flex flex-col gap-16">
				{section && (
					<LessonsList section={section} folders={course.folders || []} />
				)}
			</div>
			<CourseInfo course={course} />
		</div>
	);
}

export default Course;
